import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { ProductService } from '../../_ecomservices/product.service';
import { SizeService } from '../../_ecomservices/size.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';


@Component({
  selector: 'app-product-size',
  templateUrl: './product-size.component.html',
  styleUrls: ['./product-size.component.css']
})
export class ProductSizeComponent implements OnInit {

  sizeDisplayedColumns: string[] = ['ID', 'SizeName', 'SizeCode', 'Action'];
  sizeDataSource: MatTableDataSource<any>;

  chartDisplayedColumns: string[] = ['ID', 'ChartName', 'ChartDescription', 'ChartImage', 'Action'];
  chartDataSource: MatTableDataSource<any>;

  constructor(public productService: ProductService,
    private dialog: MatDialog,
    public sizeService: SizeService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
    private loading: LoadingService,
    private titleService: Title,) { }

  ngOnInit() {
    this.titleService.setTitle('Product Size and Charts');
    this.loadSizes();
    this.get_size_charts();
  }

  loadSizes() {
    var result = this.sizeService.get_all_sizes().subscribe(data => {
      if (data['status']) {
        this.sizeDataSource = new MatTableDataSource<any>(data['sizes']);
      }
    });
  }

  onCreateSize() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "30%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { mobile: '' }
    this.dialog.open(ProductSizeDialogComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.loadSizes();
    });
  }

  onCreateSizeCharts() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' }
    this.dialog.open(SizeChartCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_size_charts();
    });
  }

  onEditSize(rowData: any) {
    this.sizeService.sizePoulateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "30%";
    matDialogConfig.position = { top: '10px' };
    // matDialogConfig.data = { chartId: chartId }
    this.dialog.open(ProductSizeDialogComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.loadSizes();
    });
  }


  onEditSizeChart(rowData: any) {
    this.sizeService.sizeChartsPopulateForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    // matDialogConfig.data = { chartId: chartId }
    this.dialog.open(SizeChartCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_size_charts();
    });
  }

  

  get_size_charts() {
    var result = this.sizeService.get_size_charts().subscribe(data => {
      //console.log(data['data_list']); 
      if (data['status']) {
        this.chartDataSource = new MatTableDataSource<any>(data['data_list']);
      }
    });
  }

  onDeleteSize(size: any) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this size?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.sizeService.delete_product_size(size.id).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.loadSizes();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error('Product size could not be deleted, Try Again!');
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }


  onDeleteSizeChart(chart: any) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this chart?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.sizeService.delete_product_size_chart(chart.id).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.get_size_charts();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

}





/* Create Size */
@Component({
  selector: 'create-size-dialog',
  templateUrl: 'create-size-dialog.html',
  styleUrls: ['./product-size.component.css']
})
export class ProductSizeDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ProductSizeComponent>,
    public sizeService: SizeService,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
  ) {
  }

  onSizeFormSubmit(formData: any) {
    if (this.sizeService.size_form.valid) {
      this.loading.spin$.next(true);
      if (!this.sizeService.size_form.controls['id'].value) {
        // Insert Data
        this.sizeService.insert_size(formData).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success('Product Size Created Successfully.');
            this.sizeService.size_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Product Size could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.sizeService.update_size(formData).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success('Size data updated Successfully.');
            this.sizeService.size_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Size data could not be updated, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    // console.log('Close');
    this.sizeService.size_form.reset();
    this.dialogRef.close();
  }

}







/* Create Size Chart */
@Component({
  selector: 'create-size-chart-dialog',
  templateUrl: 'create-size-chart-dialog.html',
  styleUrls: ['./product-size.component.css']
})
export class SizeChartCreateComponent {

  chart_image: File = null;
  // chartImagePreview: string | ArrayBuffer | null = null;

  constructor(
    private dialogRef: MatDialogRef<ProductSizeComponent>,
    public sizeService: SizeService,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public dialogService: DialogService,
  ) {
  }


  onSelectSizeChartImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.chart_image = file;
      // this.sizeService.size_chart_form.patchValue({ chart_image: file });      
      //this.sizeService.size_chart_form.get('chart_image')!.updateValueAndValidity();
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.sizeService.chartImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }


  onSizeChartAddedFormSubmit(formData: any) {
    if (this.sizeService.size_chart_form.valid) {
      this.loading.spin$.next(true);
      if (!this.sizeService.size_chart_form.controls['id'].value) {
        // Insert Data
        this.sizeService.insert_sizechart(formData, this.chart_image).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.sizeService.size_chart_form.reset();
            this.chart_image = null;
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Size Chart could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.sizeService.update_sizechart(formData, this.chart_image).subscribe(data => {
          //console.log(data);
          if (data['status']) {
            this.notificationService.success('Size Chat data updated Successfully.');
            this.sizeService.size_chart_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Size Chat data could not be updated, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }




  onClose() {
    // console.log('Close');
    this.sizeService.size_chart_form.reset();
    this.dialogRef.close();
  }



}


